import { DateOnly } from '../repositories';


/**
 * Convert date in string format according to locale language.
 */
export function convertToLocalDate(value: Date, UTCMode = true, time = false): string {
	if (!value) return '';
	const date = new Date(value);
	const lang: string = navigator.language;
	let options: Intl.DateTimeFormatOptions = { numberingSystem: 'latn' };
	if (UTCMode) options = { ...options, timeZone: 'UTC' };
	if (time) options = { ...options, day: 'numeric', month: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: false };
	const locale = new Intl.DateTimeFormat(lang, options).format(date);
	const raw = locale?.replace(/\u200f/g, ''); // remove rtl escape char
	return raw;
}

/**
* Convert date in string ISO format.
*/
export function convertToISOString(date: Date): string {
	const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
	const isoString = utcDate.toISOString();
	return isoString;
}

/**
 * Get number of days between two dates.
 */
export function daysDiff(date1?: Date, date2?: Date): number {
	return date1 && date2 ? Math.abs(Math.round((date1.getTime() - date2.getTime()) / 86400000)) : 0;
}

/**
 * Add days to input date.
*/
export function addDays(date: DateOnly, days: number): DateOnly {
	return new DateOnly(new DateOnly(date).getTime() + days * 86400000);
}

/**
 * Get number of hours between two dates.
 */
export function hoursDiff(date1?: Date, date2?: Date): number {
	return date1 && date2 ? Math.abs(Math.round((date1.getTime() - date2.getTime()) / 3600000)) : 0;
}